import type { ComponentType } from "react";
import type { WidgetAggregationConfig, WidgetPreviewResponse, WidgetTemplateDetail } from "@/modules/widget/types";
import type { BrandKit } from "@/modules/brand/types";
import TemplateClassicCard from "./template-classic-card";
import TemplateClassicList from "./template-classic-list";
import TemplateClassicCarousel from "./template-classic-carousel";
import TemplateClassicRatingBadge from "./template-classic-rating-badge";
import TemplateClassicMasonryGrid from "./template-classic-masonry-grid";
import TemplateClassicHorizontalScroll from "./template-classic-horizontal-scroll";
import TemplateClassicAvatarStack from "./template-classic-avatar-stack";

export interface WidgetTemplateProps {
	previewData: WidgetPreviewResponse | null;
	layoutConfig: Record<string, unknown>;
	templateDetail: WidgetTemplateDetail | null;
	aggregationConfig: WidgetAggregationConfig | null;
	brandKit?: BrandKit | null;
	showBranding?: boolean;
	nextCursor?: string | null;
	onLoadMore?: () => Promise<void>;
	isLoadingMore?: boolean;
}

const TEMPLATE_COMPONENTS: Record<string, ComponentType<WidgetTemplateProps>> = {
	"classic-card": TemplateClassicCard,
	"classic-list": TemplateClassicList,
	"classic-carousel": TemplateClassicCarousel,
	"classic-rating-badge": TemplateClassicRatingBadge,
	"classic-masonry-grid": TemplateClassicMasonryGrid,
	"classic-horizontal-scroll": TemplateClassicHorizontalScroll,
	"classic-avatar-stack": TemplateClassicAvatarStack,
};

interface WidgetTemplateRouterProps extends WidgetTemplateProps {
	template: string;
}

export default function WidgetTemplateRouter({ template, ...props }: WidgetTemplateRouterProps) {
	const TemplateComponent = TEMPLATE_COMPONENTS[template];

	if (!TemplateComponent) {
		if (import.meta.env.DEV) {
			console.warn(`Widget template "${template}" not found`);
		}
		return <div className="text-sm text-tertiary text-center py-12">Preview not available for this template.</div>;
	}

	return <TemplateComponent {...props} />;
}
